import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {
    AddAssistanceApplicationInformationRequestViewModel,
} from '../../../../../../services/api.client';
import {
    AssistanceApplicationReviewService
} from "../../../../../../services/assistance-application-review.service";

@Component({
    selector: 'app-info-requested',
    templateUrl: './info-requested.component.html',
    styleUrls: ['./info-requested.component.scss'],
    standalone: false
})
export class InfoRequestedComponent {

    constructor(private _infoRequestService: AssistanceApplicationReviewService) {
    }

    @Input() assistanceApplicationId: string;
    @Output() closeModal = new EventEmitter();
    public isProcessing = false;

    private _fb = inject(FormBuilder);

    get comments(): FormControl {
        return this.form?.get('comments') as FormControl;
    }

    form = this._fb.group({
        comments: new FormControl('', Validators.required)
    });

    onClickCancel(): void {
        this.closeModal.emit();
        this.resetForm();
    }

    onClickConfirmInfoRequest(): void {
        if (this.isProcessing) {
            return;
        }
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        this.isProcessing = true;
        this._infoRequestService.addInformationRequest(AddAssistanceApplicationInformationRequestViewModel.fromJS({
            assistanceApplicationId: this.assistanceApplicationId,
            note: this.comments.value
        }))
            .subscribe({
                next: () => {
                    this.resetForm();
                    this.isProcessing = false;
                    this.closeModal.emit();
                    window.location.reload();
                },
                error: err => {
                    console.error(err);
                    this.isProcessing = false;
                }
            });
    }

    private resetForm(): void {
        this.comments.markAsUntouched();
        this.comments.setValue('');
    }
}
